module.exports = __webpack_public_path__ + "images/drawings/sun_red.63e8d877085850d08325bc85ea71216e.png";